import React from "react";
import PropTypes from "prop-types";
import Pagination from "./ApiPaginationController";

const DualPagination = ({
  gotoPage,
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  pageIndex,
  pageCount,
  pageOptions,
  setPageSize,
  pageSize,
  dataLength,
  onPaginationChange,
  pageSizeOptions
}) => {
  return (
    <div className="d-flex flex-wrap mt-5 mb-5 search">
      {/* Left pagination - page size + dropdown */}
      <div className="pe-2">
        <Pagination
          gotoPage={gotoPage}
          pageIndex={pageIndex}
          pageCount={pageCount}
          pageOptions={pageOptions}
          setPageSize={setPageSize}
          pageSize={pageSize}
          dataLength={dataLength}
          showButtons={false}
          onPaginationChange={onPaginationChange}
          pageSizeOptions={pageSizeOptions}
        />
      </div>

      {/* Right pagination - previous/next buttons */}
      <Pagination
        gotoPage={gotoPage}
        previousPage={previousPage}
        nextPage={nextPage}
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageCount={pageCount}
        pageOptions={pageOptions}
        setPageSize={setPageSize}
        dataLength={dataLength}
        showButtons
        onPaginationChange={onPaginationChange}
        pageSizeOptions={pageSizeOptions}
      />
    </div>
  );
};

DualPagination.propTypes = {
  gotoPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  canPreviousPage: PropTypes.bool.isRequired,
  canNextPage: PropTypes.bool.isRequired,
  pageIndex: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  pageOptions: PropTypes.array.isRequired,
  setPageSize: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  dataLength: PropTypes.number.isRequired,
  onPaginationChange: PropTypes.func,
  pageSizeOptions: PropTypes.array
};

export default DualPagination;
